import { API_URL } from '../../../app-config/constants';
import { EmailTemplatePreview, EmailTemplateType } from '../../../types/EmailTemplateDto';
import { get } from '../request';

getPreview.operation = 'READ';
export function getPreview(
    type: EmailTemplateType,
    options: { reviewCycleId?: string; feedbackCycleId?: string } = {}
) {
    return get<EmailTemplatePreview>(`${API_URL}/email-templates/preview/${type}`, {
        getData: options,
    });
}

getPreviewForCompany.operation = 'READ';
export function getPreviewForCompany(type: EmailTemplateType, companyId: string) {
    return get<EmailTemplatePreview>(`${API_URL}/companies/${companyId}/emails/preview/${type}`);
}

invalidate.invalidates = ['getPreview', 'getPreviewForCompany'];
export function invalidate() {
    return Promise.resolve();
}
